import React from 'react'

import { useRouteParams } from '~/hooks/useRouteParams'
import { exists } from '~/utils'

// TODO: 外部モジュールへの依存を消したい
import {
  useSurveyBrandAccountQuery,
  useSurveyBrandAccountQueryData,
} from '../useSurveyBrandAccountQuery'

export const useCommonQueryCurrentSurveysBrandAccount = () => {
  const { brandAccountId, surveyId } = useRouteParams()

  const { isLoading } = useSurveyBrandAccountQuery(surveyId)
  const data = useSurveyBrandAccountQueryData(surveyId)

  return React.useMemo(() => {
    if (exists(brandAccountId) || !exists(surveyId)) {
      return undefined
    }

    if (isLoading) {
      return undefined
    }

    return data
  }, [brandAccountId, data, isLoading, surveyId])
}
